import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Dynamically import i18n to prevent render-blocking
const i18nPromise = import('./i18n')

// Minimal loading state while i18n initializes
const Main = () => (
  <StrictMode>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </StrictMode>
)

createRoot(document.getElementById('root')!).render(<Main />)

// Preload i18n in background
i18nPromise.catch(() => {
  // Silently handle any initialization errors
})
